var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-list"},[_c('GlobalInfoBar',{attrs:{"title":"平台商户账务","content":"操作平台所有商户的上下账，查看上下账记录"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('From',{attrs:{"tabActive":_vm.tabActive}})],1),_c('Table',{on:{"tabChange":_vm.tabChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }